import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons";
import "./servicesmenu.scss";

function ServicesMenu(props) {
  return (
    <button className="btn servicemenubtn d-flex align-items-center justify-content-center mb-4">
      <img className="left" src={props.url} alt="images" />
      <h6 className="middle">{props.text}</h6>
      <FontAwesomeIcon
        icon={faArrowAltCircleRight}
        size="2x"
        className="right"
      />
    </button>
  );
}

export default ServicesMenu;
